var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "promotion-tabs" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "优惠活动列表", name: "table" } },
            [
              _c("promotion-table-pane", {
                ref: "promotion_table_pane",
                on: { toConfig: _vm.handleConfig },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.activeName === "config"
            ? _c(
                "el-tab-pane",
                { attrs: { label: "设置优惠活动", name: "config" } },
                [
                  _c("promotion-config-pane", {
                    ref: "promotion_config_pane",
                    attrs: { "promotion-fn-id": _vm.promotionFnId },
                    on: { success: _vm.handleSuccess },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }